<template>
    <div>
        <el-popover width="190" v-model="visible" placement="bottom-start">
            <div class="day-list">
                <div class="day-item" v-for="(item) in 28" :key="item" :class="item == selectDay ? 'select' : ''"
                    @click="select(item)">{{ item }}</div>
            </div>
            <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                <el-button type="primary" size="mini" @click="changeDay">确定</el-button>
            </div>
            <div slot="reference" class="select-date">
                <div>当前提现日：</div>
                <div>{{ day }}</div>
            </div>
        </el-popover>
    </div>
</template>

<script>

export default {
    data() {
        return {
            day: 0,
            selectDay: 1,
            visible: false,
        }
    },
    created() {
        this.getDay()
    },
    watch: {
        visible: function (newVal) {
            if(newVal==false){
                this.getDay()
            }
        }
    },
    methods: {
        select(item) {
            this.selectDay = item
        },
        changeDay() {
            this.$axios.post('/admin/earn/updateCashDay', { cashDay: this.selectDay }).then((res) => {
                console.log(33333333, res);
                if (res.code == 0) {
                    this.$message({
                        showClose: true,
                        message: '更新成功',
                        type: 'success',
                    })
                    this.visible = false
                }
            })
        },
        //获取规则列表
        getDay() {
            this.$axios.get('/admin/earn/getCashDay').then((res) => {
                console.log(33333333, res);
                if (res.code == 0) {
                    this.day = res.data
                    this.selectDay = res.data
                }
            })
        },
    },
}
</script>

<style scoped>
.el-button {
    padding: 0 10px;
    height: 35px;
    line-height: 35px;
    font-size: 15px;
    margin-right: 10px;
}

.select-date {
    width: 130px;
    height: 30px;
    border-radius: 16px;
    margin: 30px 0 0 30px;
    padding-left: 20px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border: 2px solid #ccc;
}

.day-list {
    display: flex;
    flex-wrap: wrap;
}

.day-list .day-item {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    text-align: center;
    line-height: 30px;
    background-color: #f4f4f4;
    margin-bottom: 8px;
    margin-right: 8px;
    cursor: pointer;
}

.select {
    background-color: #409EFF !important;
    color: #fff;
}
</style>